import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';

@Component({
  selector: 'app-how-it-works',
  templateUrl: './how-it-works.component.html',
  styleUrl: './how-it-works.component.scss'
})
export class HowItWorksComponent implements AfterViewInit {
  @ViewChild('sellAndBuy') sellAndBuy!: ElementRef;

  ngAfterViewInit(): void {
    if (this.sellAndBuy?.nativeElement) {

      const children = this.sellAndBuy?.nativeElement?.querySelectorAll('.sell-and-buy__item');

      children.forEach((child: HTMLElement) => {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.classList.add('animate');
              } else {
                entry.target.classList.remove('animate');
              }
            });
          },
          { threshold: 0.5 }
        );

        observer.observe(child);
      });
    }
  }
}
